import React from 'react';
import { Field, ErrorMessage } from 'formik';

export const StepNine = () => (
  <div className="w-full max-w-md mx-auto p-6 bg-white shadow-md rounded-md   step9">
    {/* <h6 className="text-lg font-bold mb-6">Additional Questions</h6> */}

    <div className="mb-6 ">
      <div className="cdf__field__wrapper   form-text2-main ">
        <p>
          <strong>Ask any questions here about your case</strong>
        </p>
        <Field rows={8} name="questions" component="textarea" maxLength="1500" />
        <ErrorMessage name="questions" component="div" className="required-text" />
      </div>
    </div>
  </div>
);
